import { Component } from "@angular/core";
import { LgGridContainerDirective } from "@legal-and-general/canopy";
import { Store } from "@ngrx/store";
import { ComponentLoaderService } from "../../../services/component-loader/component-loader.service";
import { GlobalState } from "../../../store/global/global.reducer";
import { LoaderComponent } from "../../utils/dynamic-loader/loader.component";
import { BaseLayoutComponent } from "../BaseLayout/BaseLayout.component";
import { NgClass } from "@angular/common";

@Component({
  selector: "dotcom-frontend-home-page",
  templateUrl: "./DefaultLayout.component.html",
  styleUrl: "./DefaultLayout.component.scss",
  standalone: true,
  imports: [LoaderComponent, LgGridContainerDirective, NgClass]
})
export class DefaultLayoutComponent extends BaseLayoutComponent {
  constructor(
    store: Store<{ global: GlobalState }>,
    componentLoaderService: ComponentLoaderService
  ) {
    super(store, componentLoaderService);
  }
}
